import Input from '../common/Input';
import { generateSeasonOptions } from '../../utils/seasonUtils';

/**
 * Application Settings Component
 * Form for configuring application URLs and basic info
 */
export default function ApplicationSettings({ settings, onChange }) {
  const handleChange = (field, value) => {
    onChange({ ...settings, [field]: value });
  };

  // Generate volleyball season options
  const seasonOptions = generateSeasonOptions(10);

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-medium text-gray-900">Application Configuration</h3>
        <p className="mt-1 text-sm text-gray-500">
          Configure application URLs and basic information
        </p>
      </div>

      <div className="grid grid-cols-1 gap-6">
        <Input
          label="Application Name"
          value={settings.name || ''}
          onChange={(e) => handleChange('name', e.target.value)}
          placeholder="Trainers Contract System"
        />

        <Input
          label="Backend URL"
          value={settings.url || ''}
          onChange={(e) => handleChange('url', e.target.value)}
          placeholder="http://localhost:5001"
          helpText="URL where the backend API is hosted"
        />

        <Input
          label="Frontend URL"
          value={settings.frontend_url || ''}
          onChange={(e) => handleChange('frontend_url', e.target.value)}
          placeholder="http://localhost:3000"
          helpText="URL where the frontend application is hosted (used in email links)"
        />

        <Input.Select
          label="Current Volleyball Season"
          value={settings.volleyball_season || ''}
          onChange={(e) => handleChange('volleyball_season', e.target.value)}
          helpText="Default contract dates will be September 1st to June 30th based on selected season"
        >
          <option value="">Select a volleyball season...</option>
          {seasonOptions.map((season) => (
            <option key={season} value={season}>
              {season}
            </option>
          ))}
        </Input.Select>
      </div>
    </div>
  );
}